import React from 'react';
import styles from './CustomItem.module.scss';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../../components/dropdownSelect/DropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import { nameTableColumn } from '../../../constants/nameTableRso';
import { useSelector } from 'react-redux';

const CustomItem = ({
  form,
  options,
  fieldName,
  highlightColorName,
  label,
  requiredMessage,
  onChange,
  highlightColor,
  isClear = false,
  disabled = false,
  isSignature = false,
}) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const valueForm = useSelector((state) => state.rsoImportStore.valueForm);

  const optionsRender =
    typeof options === 'function' ? options(fieldName) : options;

  const value = getFieldValue(fieldName);

  const columnTariffValue = getFieldValue(nameTableColumn.columnTariff);

  const addresses = valueForm.columnsAddress || [];
  const isStartAddress = nameTableColumn?.columnsAddressStart === fieldName;
  const isEndAddress = nameTableColumn?.columnsAddressEnd === fieldName;

  return (
    <div className={styles.itemBox}>
      <Form.Item
        label={label}
        labelCol={{ span: 11, style: { textAlign: 'left' } }}
        wrapperCol={{ span: 13 }}
        style={{ display: 'flex', flex: 1, margin: 0 }}
      >
        {getFieldDecorator(fieldName, {
          initialValue: isStartAddress
            ? addresses[0]
            : isEndAddress && addresses.length > 1
            ? addresses[addresses.length - 1]
            : valueForm[fieldName] ?? undefined,
          rules: requiredMessage
            ? [
                {
                  required: true,
                  message: requiredMessage,
                },
              ]
            : [],
        })(
          <DropdownSelect
            options={optionsRender}
            onChange={(val) => {
              onChange(fieldName, val);
              if (
                fieldName === nameTableColumn.columnTariff &&
                val !== columnTariffValue
              ) {
                setFieldsValue({
                  [nameTableColumn.MeterTriffs_One]: undefined,
                  [nameTableColumn.MeterTriffs_Two]: undefined,
                });
              }
            }}
            multiple={false}
            renderControl={getRenderControl({
              options: optionsRender,
              isClear,
              onClearClick: () => {
                if (getFieldValue(fieldName) !== undefined) {
                  if (fieldName === nameTableColumn.columnsAddressStart) {
                    setFieldsValue({
                      [nameTableColumn.columnsAddressEnd]: undefined,
                    });
                    onChange(nameTableColumn.columnsAddressEnd, undefined);
                  }
                  setFieldsValue({ [fieldName]: undefined });
                  onChange(fieldName, undefined);
                }
              },
              value,
              disabled,
            })}
          />
        )}

        {isSignature && (
          <div style={{ fontSize: 14, color: '#888', lineHeight: '20px' }}>
            Если в диапазон попали столбцы не относящиеся к адресу они будут
            проигнорированы
          </div>
        )}
      </Form.Item>

      <div
        style={{
          backgroundColor: highlightColor(
            highlightColorName ? highlightColorName : fieldName
          ),
        }}
        className={styles.blockColor}
      />
    </div>
  );
};

export default CustomItem;
